import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'reactstrap';
import BreadCrumb from "../../Components/Common/BreadCrumb";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import ProjectDashboardCard from "../../Components/ProjectDashboard/projectDashCard";
import { getUserDetails } from "../../api/casp/user";
import { useDispatch, useSelector } from "react-redux";
import { Role } from "../../constants/Role";
import { unSetCurrentProjectRole } from "../../store/roles";
import { Helmet } from 'react-helmet';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { getIconPath } from "../../helpers/file_helper";
import { filter } from 'lodash/collection'
import { get } from 'lodash/object'
import NoAccountsOutlinedIcon from '@mui/icons-material/NoAccountsOutlined';
import { withTranslation } from "react-i18next";
import { RemoveRedEye } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";


function AllProjectDashboard({ sectionHeading, t }) {
    const [roleArray, setRoleArray] = useState([])
    const navigate = useNavigate()
    const [projectRole, setProjectRole] = useState([{
        role: '',
        project: [{
            id: 0,
            name: ''
        }]
    }])
    const dispatch = useDispatch()

    const projectRoles = [
        Role.PORTFOLIO_MANAGER,
        Role.PROJECT_SPONSOR,
        Role.PROJECT_OWNER,
        Role.PROJECT_MANAGER,
        Role.MEMBER
    ];

    const loggedInUser = useSelector((state) => state.Profile.user);

    useEffect(() => {
        dispatch(unSetCurrentProjectRole())
        userDetails()
    }, [])

    const userDetails = async () => {
        const res = (await getUserDetails(loggedInUser.id)).data.data;
        let result = []
        result = res?.roleArray?.map((role) => {
            const roleData = res?.projectUsers?.filter((el) => el.role.name === role.name)
            setRoleArray(res.roleArray.map(it => it.name))
            const project = roleData.map((pro) => {
                return {
                    id: pro.project.id,
                    name: pro.project.name,
                    status: pro.project.status
                }
            })

            return {
                role: role.name,
                project
            }
        })
        setProjectRole(result)
    };

    return (
        <div className="projDashboardPg page-content position-relative">
            <Helmet
                onChangeClientState={(newState, addedTags) => {
                    try {
                        // Check if we added any new link[rel="icon"] elements.
                        const newFaviconElems = filter(get(newState, 'linkTags', []), {
                            rel: 'icon',
                        })

                        if (!newFaviconElems.length) {
                            return
                        }

                        // Get the href of the last link element we just added, which
                        // we assume is the most recently-added favicon.
                        const newFaviconHref =
                            newFaviconElems[newFaviconElems.length - 1].href

                        // Remove all react-helmet link elements with rel="icon" that
                        // do not have the href of our recently-added favicon.
                        // If no other favicon elements exist, we don't have to do
                        // anything.
                        const existingFavicons = document.querySelectorAll(
                            `link[rel="icon"][data-react-helmet]:not([href="${newFaviconHref}"])`
                        )

                        if (existingFavicons.length) {
                            existingFavicons.forEach(e => e.parentNode.removeChild(e))
                        }

                        // Remove and re-add the latest link element to make sure
                        // the browser uses it.
                        const newFaviconElem = document.querySelector(
                            `link[rel="icon"][data-react-helmet][href="${newFaviconHref}"]`
                        )

                        if (newFaviconElem) {
                            const newFavElement = newFaviconElem.cloneNode(true)
                            newFavElement.href = `data:image/svg+xml,${encodeURIComponent(
                                `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${getIconPath(<SettingsOutlinedIcon />)}</svg>`
                            )}`
                            const parentElem = newFaviconElem.parentNode
                            parentElem.removeChild(newFaviconElem)
                            parentElem.appendChild(newFavElement)
                        }
                    } catch (e) {
                        console.error(e)
                    }
                }}
            >
                {/* Set the favicon using a data URI */}
                <title>{t("All Startups")}</title>
                {/* <link
            rel="icon"
            type="image/x-icon"
            href={`data:image/svg+xml,${encodeURIComponent(
                `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='${getIconPath(<SettingsOutlinedIcon />)}'/></svg>`
              )}`}
            /> */}
            </Helmet>
            <Container fluid>
                <div className="mainPageHeader d-flex justify-content-between align-items-start">
                    <BreadCrumb
                        title={t("All Startups")}
                    />
                </div>

                {projectRoles.map((role, index) => (
                    projectRole?.length > 0 && projectRole.map((item) => (
                        item.role.toLowerCase() === role.toLowerCase() &&
                    <div className="singleProjectSetting" key={index}>
                                <div className="sectionHeading">{t(`As ${role === Role.PROJECT_MANAGER ? 'Founder' : role === Role.PORTFOLIO_MANAGER ? 'Manager' : role?.replace('Project', 'Startup')}`)}
                                    {/* {[Role.EPMO_OFFICER, Role.PROJECT_OWNER, Role.PROJECT_SPONSOR, Role.MEMBER, Role.PROJECT_MANAGER, Role.PORTFOLIO_MANAGER].includes(role) && (
                                    <span className="ms-2">
                                        <Button
                                            onClick={() => {
                                                navigate(`/project-dashboard-new`, {
                                                    state: {
                                                        role: JSON.stringify(role)
                                                    }
                                                })
                                            }}
                                            style={{ border: 'unset'}}
                                            className="main-login-btn btn btn-secondary"
                                        >
                                            <RemoveRedEye className="me-2" style={{ fontSize: '17px' }} /> {t('View Dashboard')}
                                        </Button>
                                    </span>
                                    )} */}
                                </div>
                        <div className="sectionBody">
                            <div className="projSettingsListing list-inline">
                                <div className="gy-3 gx-5 text-center">
                                    <div className="d-flex my-4 w-100 flex-wrap justify-content-between">
                                        {item.project.map((pro) => (
                                            <div className="singleProjectCard mb-3" key={pro.id}>
                                                <ProjectDashboardCard role={role} project={pro} />
                                            </div>
                                        ))}
                                    
                                    </div>
                                    {/* {!(roleArray.map((_v) => _v.toLowerCase())).includes(role.toLowerCase()) && (
                                        <div className="greyNoDataText d-flex flex-column align-items-center">
                                            <NoAccountsOutlinedIcon />
                                            {t(`You're not assigned to any project as ${role}`)}
                                        </div>
                                    )} */}
                                    {/* {[...Array(3).keys()].map((itemIndex) => (
                                        <Col lg={6} key={itemIndex}>
                                            <ProjectDashboardCard sectionHeading={role} title={`Project ${itemIndex+1}`} />
                                        </Col>
                                    ))}  */}
                                </div>
                            </div>
                            {/* {role === "As Project Manager" ? (
                                <div className="greyNoDataText">You're not assigned to any project as Project Manager</div>
                            ) : (
                                <div className="projSettingsListing list-inline">
                                    <Row className="gy-3 gx-5">
                                        {[...Array(3).keys()].map((itemIndex) => (
                                            <Col lg={6} key={itemIndex}>
                                                <ProjectDashboardCard sectionHeading={role} title={`Project ${itemIndex + 1}`} />
                                            </Col>
                                        ))}
                                    </Row>
                                </div>
                            )} */}
                        </div>
                    </div>
                ))))}
            </Container>
        </div>
    )
}

export default withTranslation()(AllProjectDashboard);
